 import React from 'react'
import Topbar from './Navbar'
import './text.css'
import symbol from "../StartupInsight/Images/symbol.png"
import { Link } from 'react-router-dom'
import { Form,Button } from 'react-bootstrap'
import Footer from './HomeFooter'
import Startup_card from './Startup_card'
import Typical from 'react-typical'

const Hbody2 = () => {
  return (
      <>
      <Topbar/>
      <div class="brasil" data-text="Student Incubation Cell">Student Incubation Cell</div> 
      <center><h1 className='head'>IIT DELHI</h1></center>
      <h1 className='head2'>
        <p className="head2-p">
        "CREATING{" "}
        <Typical 
          loop={Infinity}
          wrapper='b'
          steps={[
              'JOB CREATORS',
              8000,
              'ENTREPRENEURS',
              8000,
              'MONEY MAKERS',
              8000,
            ]}
          />
          "
        </p>
      </h1>
      <h1 className='head3'><a className='btn btn-explore' href="#whatwedo"><b>What We Do?</b></a></h1>
      <div className='container-fluid bg-img p-0'>
      <div className='container-fluid nopadding' style={{height: "100%",
   width: "100%",
   background: "#000000cf"}}>
       </div>

      </div>
      <div className='container-fluid'>
      {/* <div class="vl"></div> */}
         <center><h1 className='mt-5 mb-4 aboutus' style={{marginLeft:'auto',marginRight:'auto'}}>WHAT IS SInC ?</h1></center>
         <div className='container'>
          <h5 className='aboutus-h5 mb-3'> The Student Incubation Cell, IIT Delhi is formed with an intent to promote design thinking, planful ideation and support budding Entrepreneurs at IIT DELHI who can make a mark on the world map through their vision, next-generation technology, and services by leading from the front.Our mission is to empower every student in the campus in every way possible who aim high to translate their ideas into real-world Startup and to help in a smooth transition in every phase of this journey. As they say “It’s not about ideas, it’s about making ideas happen and we are committed to pave the way with every step one takes.
          <br></br> <br></br> Well! we construct roadmaps and keep to the deadlines we set. We never back 
                down and always follow through on our promises. We believe in transparency; 
                thus, our startup members and acquaintances are always kept up to date on 
                the latest events and happenings.
          </h5>
         {/* <center> <Link to="/team" className=" btn mt-3">Know More</Link> </center> */}
         </div>
      </div>
      <div className='container-fluid bg-contact p-0'>
      <div className='container-fluid nopadding' style={{height: "100%",
   width: "100%", 
    background: "#000000cf"}}>
        <div className='container mt-5'>
          <br></br><br></br>
          <h1 style={{color:'white'}}>Startup-Insight</h1>
          <br></br>
          <h7 className='mt-3' style={{color:'white'}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. In eu mi bibendum neque egestas. Tincidunt nunc pulvinar sapien et.or sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. In eu mi bibendum neque egestas. Tincidunt nunc pulvinar sapien et. Neque viverra justo nec ultrices dui</h7>
          <center><Link className='btn mt-3' style={{background:'black', color:'white'}} to='/registerpage'>Register Now</Link></center>
          <div className="startupinsightbottom">
         
        <div className="startupinsightbox2">
          <div className="startupinsightbox-heading">YONO</div>
          <div className="startupinsightbox-symbol">
            
          </div>
          <div className="startupinsightbox-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
        <div className="startupinsightbox9">
          <div className="startupinsightbox-heading">YONO</div>
          <div className="startupinsightbox-symbol">
            
          </div>
          <div className="startupinsightbox-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
        <div className="startupinsightbox4">
          <div className="startupinsightbox-heading">YONO</div>
          <div className="startupinsightbox-symbol">
            
          </div>
          <div className="startupinsightbox-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
        <div className="startupinsightbox5">
          <div className="startupinsightbox-heading">YONO</div>
          <div className="startupinsightbox-symbol">
            
          </div>
          <div className="startupinsightbox-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
        <div className="startupinsightbox6">
          <div className="startupinsightbox-heading">YONO</div>
          <div className="startupinsightbox-symbol">
            
          </div>
          <div className="startupinsightbox-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
        <div className="startupinsightbox9">
          <div className="startupinsightbox-heading">YONO</div>
          <div className="startupinsightbox-symbol">
            
          </div>
          <div className="startupinsightbox-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
        <div className="startupinsightbox8">
          <div className="startupinsightbox-heading">YONO</div>
          <div className="startupinsightbox-symbol">
            
          </div>
          <div className="startupinsightbox-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
        <div className="startupinsightbox9">
          <div className="startupinsightbox-heading">YONO</div>
          <div className="startupinsightbox-symbol">
            
          </div>
          <div className="startupinsightbox-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
        <div className="startupinsightbox7">
          <div className="startupinsightbox-heading">YONO</div>
          <div className="startupinsightbox-symbol">
            
          </div>
          <div className="startupinsightbox-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
       </div> 
       </div>
      </div>
      <div className='container'>
        <div className='row'>
        
          <center><h3 className='mt-3 mb-2' style={{color:'black'}}>Want To Learn More About INCUBATION CELL ? </h3></center><br></br>
          <div className='row mt-3'>
            <div className='col-md-6'>
            <iframe src="https://www.youtube.com/embed/DPzs3Nb4MhQ?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <br/>
            <div className='col-md-6'>
            <iframe src="https://www.youtube.com/embed/FzMfzUKd-gw?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
          </div>
        </div>
      </div>

      <div className='container-fluid mt-5' style={{background:'azure'}}>
        <br></br>
        <center><h1>Events</h1></center>
        <Startup_card/>
      </div>
     
       <Footer/> 
  
      </>
   
  )
}

export default Hbody2
